import { Injectable } from '@angular/core';
import { Router, NavigationEnd, ActivatedRouteSnapshot, Data } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

export interface Breadcrumb {
    label: string;
    url: string;
}

@Injectable({
    providedIn: 'root'
})
export class BreadcrumbService {
    private readonly breadcrumbsSubject = new BehaviorSubject<Breadcrumb[]>([]);
    breadcrumbs$ = this.breadcrumbsSubject.asObservable();

    constructor(private router: Router) {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            const root = this.router.routerState.snapshot.root;
            const breadcrumbs: Breadcrumb[] = [];
            this.addBreadcrumb(root, [], breadcrumbs);
            this.breadcrumbsSubject.next(breadcrumbs);
        });
    }

    private addBreadcrumb(route: ActivatedRouteSnapshot, parentUrl: string[], breadcrumbs: Breadcrumb[]) {
        if (route) {
            const routeUrl = parentUrl.concat(route.url.map(url => url.path));
            const url = '/' + routeUrl.join('/');

            if (route.data['breadcrumb']) {
                // Skip duplicate URLs (happens when a child route has an empty path)
                const alreadyAdded = breadcrumbs.some(b => b.url === url);
                if (!alreadyAdded) {
                    breadcrumbs.push({ label: route.data['breadcrumb'], url });
                }
            }

            this.addBreadcrumb(route.firstChild!, routeUrl, breadcrumbs);
        }
    }
}
